import * as types from "../action/ActionType";

interface EditAction {
  type: string;
  payload: boolean;
}

export default function EditReducer(state: boolean = false, action: EditAction): boolean {
  const { type, payload } = action;
  switch (type) {
    case types.TURN_FLAG:
      return payload;
    default:
      return state;
  }
}
